// extracted by mini-css-extract-plugin
export var cardSelected = "_ff-2";
export var image = "_ff-1";
export var table = "_ff-0";